@if (builderLoading$ | async) {
<div class="loader">
  <div class="loader-content">
    <fa-icon size="2x" [icon]="['fas', 'spinner']" [spin]="true"></fa-icon>
  </div>
</div>
} @if (builderHasError$ | async) {
<div class="p-5">
  <atx-empty-placeholder [icon]="['fas', 'exclamation-triangle']">
    <ng-container
      title
      i18n="
        BuilderContent|Builder content template error
        title@@builderContentTemplateErrorTitle"
    >
      Not found error
    </ng-container>
    <ng-container
      msg
      i18n="
        BuilderContent|Builder content template error
        description@@builderContentTemplateErrorDescription"
    >
      The resource you are trying to access was not found. Try again by
      refreshing the page.
    </ng-container>
  </atx-empty-placeholder>
</div>
}
<div #builder></div>
